import Vue from "vue";

import "./styles/quasar.scss";
import iconSet from "quasar/icon-set/mdi-v5.js";
import "@quasar/extras/roboto-font/roboto-font.css";
import "@quasar/extras/material-icons/material-icons.css";
import "@quasar/extras/fontawesome-v6/fontawesome-v6.css";
import "@quasar/extras/ionicons-v4/ionicons-v4.css";
import "@quasar/extras/mdi-v4/mdi-v4.css";
import "@quasar/extras/animate/fadeIn.css";
import "@quasar/extras/animate/fadeOut.css";
import "@quasar/extras/animate/slideInRight.css";
import "@quasar/extras/animate/slideOutRight.css";

import Quasar from 'quasar/src/vue-plugin.js';import Notify from 'quasar/src/plugins/Notify.js';import AppFullscreen from 'quasar/src/plugins/AppFullscreen.js';;

Vue.use(Quasar, {
  extras: ["Material-icons", "Fontawesome", "fontawesome-v6"],
  config: {
    notify: {
      position: "top-right",
      timeout: 2500,
      progress: true,
      actions: [{ icon: "close", color: "white" }],
    },
  },
  plugins: {
    Notify,
    AppFullscreen,
  },
  iconSet: iconSet,
});

Notify.registerType("refresh", {
  position: "top-right",
  timeout: 2500,
  progress: true,
});
